/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShipQuantityPlan } from './ShipQuantityPlan';
import {
    ShipQuantityPlanFromJSON,
    ShipQuantityPlanFromJSONTyped,
    ShipQuantityPlanToJSON,
    ShipQuantityPlanToJSONTyped,
} from './ShipQuantityPlan';
import type { ArrivalQuantityPlan } from './ArrivalQuantityPlan';
import {
    ArrivalQuantityPlanFromJSON,
    ArrivalQuantityPlanFromJSONTyped,
    ArrivalQuantityPlanToJSON,
    ArrivalQuantityPlanToJSONTyped,
} from './ArrivalQuantityPlan';

/**
 * 
 * @export
 * @interface StockPlanUpdateBase
 */
export interface StockPlanUpdateBase {
    /**
     * PSI企業ID
     * @type {number}
     * @memberof StockPlanUpdateBase
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof StockPlanUpdateBase
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockPlanUpdateBase
     */
    itemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockPlanUpdateBase
     */
    orgCenterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockPlanUpdateBase
     */
    orgItemCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockPlanUpdateBase
     */
    orgSupplierId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof StockPlanUpdateBase
     */
    recDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof StockPlanUpdateBase
     */
    orderDate?: Date | null;
    /**
     * 
     * @type {ShipQuantityPlan}
     * @memberof StockPlanUpdateBase
     */
    shipQuantityPlan?: ShipQuantityPlan | null;
    /**
     * 
     * @type {ArrivalQuantityPlan}
     * @memberof StockPlanUpdateBase
     */
    arrivalQuantityPlan?: ArrivalQuantityPlan | null;
    /**
     * 
     * @type {number}
     * @memberof StockPlanUpdateBase
     */
    orderQuantityRecommend?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof StockPlanUpdateBase
     */
    orderRecommendCalcDatetime?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockPlanUpdateBase
     */
    olditemShipStopFlg?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StockPlanUpdateBase
     */
    remarks?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof StockPlanUpdateBase
     */
    stockPlanUpdateDatetime?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockPlanUpdateBase
     */
    isUpdatedArrivalTmp?: boolean | null;
}

/**
 * Check if a given object implements the StockPlanUpdateBase interface.
 */
export function instanceOfStockPlanUpdateBase(value: object): value is StockPlanUpdateBase {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('recDate' in value) || value['recDate'] === undefined) return false;
    return true;
}

export function StockPlanUpdateBaseFromJSON(json: any): StockPlanUpdateBase {
    return StockPlanUpdateBaseFromJSONTyped(json, false);
}

export function StockPlanUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockPlanUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'itemCode': json['item_code'],
        'orgCenterId': json['org_center_id'] == null ? undefined : json['org_center_id'],
        'orgItemCode': json['org_item_code'] == null ? undefined : json['org_item_code'],
        'orgSupplierId': json['org_supplier_id'] == null ? undefined : json['org_supplier_id'],
        'recDate': (json['rec_date'] == null ? null : new Date(json['rec_date'])),
        'orderDate': json['order_date'] == null ? undefined : (new Date(json['order_date'])),
        'shipQuantityPlan': json['ship_quantity_plan'] == null ? undefined : ShipQuantityPlanFromJSON(json['ship_quantity_plan']),
        'arrivalQuantityPlan': json['arrival_quantity_plan'] == null ? undefined : ArrivalQuantityPlanFromJSON(json['arrival_quantity_plan']),
        'orderQuantityRecommend': json['order_quantity_recommend'] == null ? undefined : json['order_quantity_recommend'],
        'orderRecommendCalcDatetime': json['order_recommend_calc_datetime'] == null ? undefined : (new Date(json['order_recommend_calc_datetime'])),
        'olditemShipStopFlg': json['olditem_ship_stop_flg'] == null ? undefined : json['olditem_ship_stop_flg'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'stockPlanUpdateDatetime': json['stock_plan_update_datetime'] == null ? undefined : (new Date(json['stock_plan_update_datetime'])),
        'isUpdatedArrivalTmp': json['is_updated_arrival_tmp'] == null ? undefined : json['is_updated_arrival_tmp'],
    };
}

export function StockPlanUpdateBaseToJSON(json: any): StockPlanUpdateBase {
    return StockPlanUpdateBaseToJSONTyped(json, false);
}

export function StockPlanUpdateBaseToJSONTyped(value?: StockPlanUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'item_code': value['itemCode'],
        'org_center_id': value['orgCenterId'],
        'org_item_code': value['orgItemCode'],
        'org_supplier_id': value['orgSupplierId'],
        'rec_date': value['recDate'] == null ? value['recDate'] : value['recDate'].toISOString(),
        'order_date': value['orderDate'] == null ? value['orderDate'] : value['orderDate'].toISOString(),
        'ship_quantity_plan': ShipQuantityPlanToJSON(value['shipQuantityPlan']),
        'arrival_quantity_plan': ArrivalQuantityPlanToJSON(value['arrivalQuantityPlan']),
        'order_quantity_recommend': value['orderQuantityRecommend'],
        'order_recommend_calc_datetime': value['orderRecommendCalcDatetime'] == null ? value['orderRecommendCalcDatetime'] : value['orderRecommendCalcDatetime'].toISOString(),
        'olditem_ship_stop_flg': value['olditemShipStopFlg'],
        'remarks': value['remarks'],
        'stock_plan_update_datetime': value['stockPlanUpdateDatetime'] == null ? value['stockPlanUpdateDatetime'] : value['stockPlanUpdateDatetime'].toISOString(),
        'is_updated_arrival_tmp': value['isUpdatedArrivalTmp'],
    };
}

